import React from 'react'

import {Slider, Skills, RecentWork} from '../components/'

const Index = () => (
    <React.Fragment>
        <Slider />
        <Skills />
        <RecentWork />
    </React.Fragment>
)

export default Index



// WEBPACK FOOTER //
// ./src/pages/index.js